import { render, staticRenderFns } from "./License.vue?vue&type=template&id=bf94d286&scoped=true"
import script from "./License.ts?vue&type=script&lang=ts&external"
export * from "./License.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94d286",
  null
  
)

export default component.exports